import Class from './c-year-list';
import './c-year-list@';

export default Class;